import React from 'react';
import { useAuth } from '../../hooks/useAuth'; // Adjust path as needed
import LoadingSpinner from '../common/LoadingSpinner';

const AuthScreen = () => {
	const { handleOAuthLogin, loading, error, enableAuthBypass, disableAuthBypass } = useAuth();

	const handleLogin = async () => {
		try {
			// Call the OAuth login - navigation will be handled by App.js
			await handleOAuthLogin();
		} catch (err) {
			console.error('Login failed:', err);
		}
	};

	return (
		<div className="screen auth-screen">
			<div className="auth-icon">🔐</div>
			<h1>Welcome to TruckScale Pro</h1>
			<p>Connect to AggMaps|Bill to continue</p>

			{error && (
				<div style={{
					marginBottom: '1rem',
					padding: '0.75rem',
					background: 'rgba(220, 38, 38, 0.1)',
					border: '1px solid rgba(220, 38, 38, 0.2)',
					borderRadius: '8px',
					color: '#dc2626',
					fontSize: '0.875rem'
				}}>
					<strong>Authentication Error:</strong> {error}
				</div>
			)}

			{loading ? (
				<LoadingSpinner text="Connecting to AggMaps|Bill..." />
			) : (
				<>
					<button
						className="btn btn-primary btn-large"
						onClick={handleLogin}
						disabled={loading}
					>
						Sign In with AggMaps|Bill
					</button>
					
					{/* DEVELOPMENT BYPASS CONTROLS */}
					{/* <div style={{
						marginTop: '1rem',
						padding: '1rem',
						background: 'rgba(255, 193, 7, 0.1)',
						border: '1px solid rgba(255, 193, 7, 0.3)',
						borderRadius: '8px',
						textAlign: 'center'
					}}>
						<p style={{ margin: '0 0 0.5rem 0', fontSize: '0.875rem', color: '#b45309' }}>
							<strong>🔧 Development Testing</strong>
						</p>
						<div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center' }}>
							<button
								className="btn btn-secondary"
								onClick={enableAuthBypass}
								style={{ fontSize: '0.8rem', padding: '0.5rem 1rem' }}
							>
								Enable Test Mode
							</button>
							<button
								className="btn btn-secondary"
								onClick={disableAuthBypass}
								style={{ fontSize: '0.8rem', padding: '0.5rem 1rem' }}
							>
								Disable Test Mode
							</button>
						</div>
						<p style={{ margin: '0.5rem 0 0 0', fontSize: '0.75rem', color: '#b45309', opacity: 0.8 }}>
							Use test mode to bypass OAuth for development
						</p>
					</div> */}
				</>
			)}

			<div style={{
				marginTop: '2rem',
				padding: '1rem',
				background: 'rgba(255, 255, 255, 0.1)',
				borderRadius: '8px',
				fontSize: '0.875rem',
				color: '#718096'
			}}>
				<p>This system requires authentication with AggMaps|Bill platform.</p>
				<p>Your credentials will be securely handled via OAuth2.</p>
				<div style={{ marginTop: '0.5rem', fontSize: '0.8rem', opacity: 0.8 }}>
					<p>• You will be redirected to AggMaps|Bill for secure login</p>
					<p>• No passwords are stored locally</p>
					<p>• Your session will be automatically managed</p>
				</div>
			</div>
		</div>
	);
};

export default AuthScreen;